import { FormView } from "../../UI/view/form-view";
import { FormItemType } from "../../UI/view/component-map";
import { initView } from "../../UI/view/view";
import { groupingsDataSource } from "./groupings-ds";
import { GetLiquidCustomersBySegment } from "../../../services/requests";

export const groupingsCreate = {
  editMode: false,
  items: [
    {
      type: FormItemType.fieldset,
      label: 'Save Liquid Customer Grouping',
      items: [
        {
          label: 'Segment',
          name: 'segment',
          type: FormItemType.select,
          defaultValue: 'Americas',
          options: [
            {
              text: 'Americas',
              id: 'Americas'
            },
            {
              text: 'APAC',
              id: 'APAC'
            },
            {
              text: 'EMEA',
              id: 'EMEA'
            },
          ],
          required: true
        },
        {/*------------America------------*/
          label: 'Liquid Customer',
          name: 'liquidCustomerId',
          type: FormItemType.select,
          hideIf: ({ watch }) => !(watch(`segment`) == "Americas"),
          onChange: async ({ evt, setValue }) => {
            setValue(`customerName`, evt.target.selectedOptions[0].text)
            setValue(`liquidCustomerId`, evt.target.value)
          }
          , options: async () => {
            const customers = await GetLiquidCustomersBySegment("Praxair");
            return [{ text: "", id: null }, ...customers.map(c => ({ id: c.customerId, text: `${c.customerName}` }))]
          },
        },
        {/*--------------EMEA-------------*/
          label: 'Liquid Customer',
          name: 'liquidCustomerId',
          type: FormItemType.select,
          hideIf: ({ watch }) => !(watch(`segment`) == "EMEA"),
          onChange: async ({ evt, setValue }) => {
            setValue(`customerName`, evt.target.selectedOptions[0].text)
            setValue(`liquidCustomerId`, evt.target.value)
          },
          options: async () => {
            const customers = await GetLiquidCustomersBySegment("Linde EMEA");
            return [{ text: "", id: null }, ...customers.map(c => ({ id: c.customerId, text: `${c.customerName}` }))]
          },
        },
        {/*--------------APAC-------------*/
          label: 'Liquid Customer',
          name: 'liquidCustomerId',
          type: FormItemType.select,
          hideIf: ({ watch }) => !(watch(`segment`) == "APAC"),
          onChange: async ({ evt, setValue }) => {
            setValue(`customerName`, evt.target.selectedOptions[0].text)
            setValue(`liquidCustomerId`, evt.target.value)
          },
          options: async () => {
            const customers = await GetLiquidCustomersBySegment("Linde APAC");
            return [{ text: "", id: null }, ...customers.map(c => ({ id: c.customerId, text: `${c.customerName}` }))]
          },
        },
        {
          label: 'Liquid Customer Id',
          name: 'liquidCustomerId',
          disabled: () => true
        },
        {
          label: 'Customer Name',
          name: 'customerName',
          disabled: () => true
        },

        {
          label: 'Grouping',
          name: 'grouping',
          required: true,
        },
        {
          label: 'Sales Manager',
          name: 'salesManager',
          required: true,
        },
      ]
    }
  ]
} as FormView;

export const groupingsEdit = {
  ...groupingsCreate,
  editMode: true
}

export const groupingsCreateForm = initView({form: groupingsCreate,dataSource: groupingsDataSource})